<ng-container *ngFor="let module of (data$ | async)?.modules">
  <ng-container *appModuleContainer="module"></ng-container>
</ng-container>
